import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base plan price
   */
  basePlanPrice: string;
  /**
   * Next billing amount
   */
  nextBillingAmount: string;
  /**
   * Next billing date
   */
  nextBillingDate: string;
  /**
   * Scheduled cancelation date
   */
  scheduledCancellationDate: string;
};

const CancellationScheduled = ({
  basePlanPrice,
  nextBillingAmount,
  nextBillingDate,
  scheduledCancellationDate,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.cancellation_date'),
          color: 'primary.dark',
        }}
        value={{
          value: scheduledCancellationDate,
          color: 'primary.dark',
          fontWeight: 0,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.base_plan_price'),
        }}
        value={{
          value: basePlanPrice,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.next_billing_amount'),
        }}
        value={{
          value: nextBillingAmount,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.next_billing_date'),
        }}
        value={{
          value: nextBillingDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
    </Box>
  );
};

export default CancellationScheduled;
